var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"head"},[_c('h1',{on:{"click":_vm.navigateHome}},[_vm._v("小码模板")]),_c('p',[_vm._v(" 【登记去向,不重复】 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }